/**
 * MIRA ScrollArea Component
 * Wraps Shadcn ScrollArea with MIRA design system styles
 */

import React from 'react';
import {
  ScrollArea as ShadcnScrollArea,
  ScrollBar as ShadcnScrollBar
} from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/scroll-area.module.css';

export const ScrollArea = React.forwardRef(
  ({ className, children, ...props }, ref) => {
    return (
      <ShadcnScrollArea
        ref={ref}
        className={cn(styles.miraScrollArea, className)}
        {...props}
      >
        {children}
      </ShadcnScrollArea>
    );
  }
);

ScrollArea.displayName = 'MiraScrollArea';

export const ScrollBar = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnScrollBar
        ref={ref}
        className={cn(styles.miraScrollBar, className)}
        {...props}
      />
    );
  }
);

ScrollBar.displayName = 'MiraScrollBar';
